const isItAndroid = /(Android)/mi.test(navigator.userAgent);

export default isItAndroid;